import { Root } from '@radix-ui/react-dialog';

const Dialog = Root;

export default Dialog;
